import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { NOTIFICATION_CLOSING_DURATION } from '../constants';
import { store } from '../store';

export interface NotificationProps {
  isNotificationDisplayed: boolean;
  title: string;
  description: string;
  status?: 'success' | 'error';
}

export const initialState: NotificationProps = {
  isNotificationDisplayed: false,
  title: '',
  description: '',
};

const notificationSlice = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    __displayNotification: (
      state,
      {
        payload,
      }: PayloadAction<Omit<NotificationProps, 'isNotificationDisplayed'>>
    ) => {
      state.isNotificationDisplayed = true;
      state.title = payload.title;
      state.description = payload.description;
      state.status = payload.status;
    },
    __hideNotification: state => {
      state.isNotificationDisplayed = false;
    },
  },
});

export const displayNotification = (
  notificationDta: Omit<NotificationProps, 'isNotificationDisplayed'>
) => {
  store.dispatch(
    notificationSlice.actions.__displayNotification(notificationDta)
  );

  setTimeout(() => {
    store.dispatch(notificationSlice.actions.__hideNotification());
  }, NOTIFICATION_CLOSING_DURATION);
};

export const notificationReducer = notificationSlice.reducer;
